"use client";
import { default as SimpleMarkdown } from "./SimpleMarkdown";

export default SimpleMarkdown;
